$(document).ready(function(){

  $('.custom_atc_button').click(function(){
    var currentId = $(this).attr('data-id');
    var mode = $(this).attr('data');
    var sellingPlanId = $(this).attr('data-sub-id');
     var quantityCur = $(this).closest('.formCont').find('.gf_pq_qty').val();
    
    
    
    console.log(mode, 'MODE');
    
    if (mode == 'sub'){
         $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function () {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        id: currentId,
                        quantity: quantityCur,
                        selling_plan: sellingPlanId
                    },
                    success: function () {
                        window.location.href = '/checkout';
                    }
                });
            }
        });

    }
    else{
        
       $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function () {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        id: currentId,
                        quantity: quantityCur
                    },
                    success: function () {
                        window.location.href = '/checkout';
                    }
                });
            }
        });

        
    }
});



  $('.custom_atc_button_cart').click(function(){
    var currentId = $(this).attr('data-id');
    var mode = $(this).attr('data');
    var sellingPlanId = $(this).attr('data-sub-id');
     var quantityCur = $(this).closest('.formCont').find('.gf_pq_qty').val();
    
    
    
    console.log(mode, 'MODE');
    
    if (mode == 'sub'){
         $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function () {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        id: currentId,
                        quantity: quantityCur,
                        selling_plan: sellingPlanId
                    },
                    success: function () {
                       
                    }
                });
            }
        });

    }
    else{
        
       $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function () {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        id: currentId,
                        quantity: quantityCur
                    },
                    success: function () {
                       
                    }
                });
            }
        });

        
    }
});



    $('.product_tab-block').click(function(){
        $(this).toggleClass('active');
        $(this).find('.product_tab-content').slideToggle();
    });


    $('.main_product-btn').click(function(){
        $('.nutrition_popup-outer').hide();
    });

    $('.nutrition_popup-outer').click(function(){
        $('.nutrition_popup-outer').hide();
    });

    $('.main_product-nutrition-info').click(function(){
        $('.nutrition_popup-outer').css('display', 'flex');
    });

    $('.product-inside_block').click(function(){
        $(this).toggleClass('active');
        $(this).find('.product-inside_block-content').slideToggle();
    });


    $('.product_faq-box').click(function(){
        $(this).toggleClass('active');
        $(this).find('.product_faq-content').slideToggle();
    });

    $('.product_carousel-prev').click(function(){
        $(this).closest('.product_carousel-outer').find('.slick-prev').trigger('click');
    });

    $('.product_carousel-next').click(function(){
        $(this).closest('.product_carousel-outer').find('.slick-next').trigger('click');
    });

    $(document).on("click",".product_ugc-video",function() {
        const video = $(this).find('video').get(0);
        const playOverlay = $(this).find('.product_ugc-play');
    
        // If this video is already playing, pause it and show play button
        if (video && !video.paused && !video.ended) {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
            playOverlay.show();
            return;
        }
    
        // Otherwise: pause all videos, reset them, and play the clicked one
        $('.product_ugc-play').show();
        $('.product_ugc-container video').each(function() {
            this.pause();
            this.currentTime = 0;
            this.muted = true;
        });
    
        if (video) {
            video.muted = false;
            video.currentTime = 0;
            video.play();
            playOverlay.hide();
        }
    });

    $('.product_primary-btn.scrolling').click(function(evt){
      evt.preventDefault();
      $('html, body').animate({
          scrollTop: $(".main_product-container").offset().top-100
      }, 500);
    });

    function getBusinessDayFromToday(offsetDays) {
          let date = new Date();
          let addedDays = 0;
  
          while (addedDays < offsetDays) {
              date.setDate(date.getDate() + 1);
              const day = date.getDay();
              if (day !== 0 && day !== 6) { // 0 = Sunday, 6 = Saturday
                  addedDays++;
              }
          }
  
          return date;
      }
  
      function formatDate(date) {
          const weekday = date.toLocaleDateString(undefined, { weekday: 'long' });
          const day = date.getDate();
          const month = date.toLocaleDateString(undefined, { month: 'long' });
          return `${weekday}, ${day} ${month}`;
      }

  
      const targetDate = getBusinessDayFromToday(3);
      const formattedDate = formatDate(targetDate);
      $(".col_pp_delivery__Date").text(formattedDate);
    
    
    $('.home_banner-reviews').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      });

    $('.main_product-image-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.main_product-image-carousel_thumbs',
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin_1.png?v=1752126281'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin.png?v=1752126281'/></button>",
      });

      $('.main_product-image-carousel_thumbs').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        asNavFor: '.main_product-image-carousel'
      });


      $('.product_ugc-container').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin_1.png?v=1752126281'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin.png?v=1752126281'/></button>",
        responsive: [
            {
              breakpoint: 677,
              settings: {
                slidesToShow: 1.3,
                slidesToScroll: 1
              }
            }
        ]
      });


      $('.product_review-container').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        allowTouchMove: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin_1.png?v=1752126281'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0917/5649/5191/files/iconamoon_arrow-up-2-thin.png?v=1752126281'/></button>",
        responsive: [
            {
              breakpoint: 677,
              settings: {
                slidesToShow: 1.7,
                slidesToScroll: 1
              }
            }
        ]
      });



  $('.main_product-videos').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px'
        }
      }
    ]
  });
});
